import { render } from "./MakeNextYearData.vue?vue&type=template&id=07d453ea&ts=true"
import script from "./MakeNextYearData.vue?vue&type=script&lang=ts"
export * from "./MakeNextYearData.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__